module.exports = __webpack_public_path__ + "8b6af8e5e8324edfd77af8b3b35d7f9c.ttf";